// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    TrackResponse,
    TrackResponseFromJSON,
    TrackResponseToJSON,
    TrackSearch,
    TrackSearchFromJSON,
    TrackSearchToJSON,
    TracksResponse,
    TracksResponseFromJSON,
    TracksResponseToJSON,
} from '../models';

export interface GetBulkTracksRequest {
    /**
     * The permalink of the track(s)
     */
    permalink?: Array<string>;
    /**
     * The ID of the track(s)
     */
    id?: Array<string>;
}

export interface GetTrackRequest {
    /**
     * A Track ID
     */
    trackId: string;
}

export interface GetTrendingTracksRequest {
    /**
     * Filter trending to a specified genre
     */
    genre?: string;
    /**
     * Calculate trending over a specified time range
     */
    time?: GetTrendingTracksTimeEnum;
}

export interface GetUndergroundTrendingTracksRequest {
    /**
     * The number of items to skip. Useful for pagination (page number * limit)
     */
    offset?: number;
    /**
     * The number of items to fetch
     */
    limit?: number;
}

export interface GetUndergroundTrendingTracksWithVersionRequest {
    /**
     * The strategy version of trending to user
     */
    version: string;
    /**
     * The number of items to skip. Useful for pagination (page number * limit)
     */
    offset?: number;
    /**
     * The number of items to fetch
     */
    limit?: number;
}

export interface SearchTracksRequest {
    /**
     * The search query
     */
    query: string;
    /**
     * Return only downloadable tracks
     */
    onlyDownloadable?: string;
}

export interface StreamTrackRequest {
    /**
     * A Track ID
     */
    trackId: string;
    /**
     * Optional - signature from the requesting user\&#39;s wallet.         This is needed to authenticate the user and verify access in case the track is premium.
     */
    userSignature?: string;
    /**
     * Optional - data which was used to generate the optional signature argument.
     */
    userData?: string;
    /**
     * Optional - premium content signature for this track which was previously generated by a registered DN.         This is so that track access won\&#39;t have to be check; instead, we check that the user which generated the         user signature and the user for whom the DN signed are the same.
     */
    premiumContentSignature?: string;
}

/**
 * 
 */
export class TracksApi extends runtime.BaseAPI {

    /**
     * Gets a list of tracks using their IDs or permalinks
     */
    async getBulkTracks(requestParameters: GetBulkTracksRequest = {}): Promise<NonNullable<TracksResponse["data"]>> {
        const queryParameters: any = {};

        if (requestParameters.permalink) {
            queryParameters['permalink'] = requestParameters.permalink;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        return this.request({
            path: `/tracks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }) as Promise<NonNullable<TracksResponse["data"]>>;
    }

    /**
     * Gets a track by ID
     */
    async getTrack(requestParameters: GetTrackRequest): Promise<NonNullable<TrackResponse["data"]>> {
        if (requestParameters.trackId === null || requestParameters.trackId === undefined) {
            throw new runtime.RequiredError('trackId','Required parameter requestParameters.trackId was null or undefined when calling getTrack.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        return this.request({
            path: `/tracks/{track_id}`.replace(`{${"track_id"}}`, encodeURIComponent(String(requestParameters.trackId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }) as Promise<NonNullable<TrackResponse["data"]>>;
    }

    /**
     * Gets the top 100 trending (most popular) tracks on Audius
     */
    async getTrendingTracks(requestParameters: GetTrendingTracksRequest = {}): Promise<NonNullable<TracksResponse["data"]>> {
        const queryParameters: any = {};

        if (requestParameters.genre !== undefined) {
            queryParameters['genre'] = requestParameters.genre;
        }

        if (requestParameters.time !== undefined) {
            queryParameters['time'] = requestParameters.time;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        return this.request({
            path: `/tracks/trending`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }) as Promise<NonNullable<TracksResponse["data"]>>;
    }

    /**
     * Gets the top 100 trending underground tracks on Audius
     */
    async getUndergroundTrendingTracks(requestParameters: GetUndergroundTrendingTracksRequest = {}): Promise<NonNullable<TracksResponse["data"]>> {
        const queryParameters: any = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        return this.request({
            path: `/tracks/trending/underground`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }) as Promise<NonNullable<TracksResponse["data"]>>;
    }

    /**
     * Gets the top 100 trending underground tracks on Audius using a given trending strategy version
     */
    async getUndergroundTrendingTracksWithVersion(requestParameters: GetUndergroundTrendingTracksWithVersionRequest): Promise<NonNullable<TracksResponse["data"]>> {
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version','Required parameter requestParameters.version was null or undefined when calling getUndergroundTrendingTracksWithVersion.');
        }

        const queryParameters: any = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        return this.request({
            path: `/tracks/trending/underground/{version}`.replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }) as Promise<NonNullable<TracksResponse["data"]>>;
    }

    /**
     * Search for a track or tracks
     */
    async searchTracks(requestParameters: SearchTracksRequest): Promise<NonNullable<TrackSearch["data"]>> {
        if (requestParameters.query === null || requestParameters.query === undefined) {
            throw new runtime.RequiredError('query','Required parameter requestParameters.query was null or undefined when calling searchTracks.');
        }

        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.onlyDownloadable !== undefined) {
            queryParameters['only_downloadable'] = requestParameters.onlyDownloadable;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        return this.request({
            path: `/tracks/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }) as Promise<NonNullable<TrackSearch["data"]>>;
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetTrendingTracksTimeEnum {
    Week = 'week',
    Month = 'month',
    Year = 'year',
    AllTime = 'allTime'
}
